import styled from 'styled-components'

export const Container = styled.div<{
  hasText?: boolean
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: auto;
  padding: ${(props) => `1rem 1rem ${props.hasText ? '2.25rem' : '0'} 1rem`};
  background: radial-gradient(
    50% 50% at 10% 20%,
    rgb(255 233 216 / 70%) 0%,
    rgba(255, 233, 216, 0.1) 100%
  );
`
